import { render, staticRenderFns } from "./BaseDrawer.vue?vue&type=template&id=e42bb1b0&scoped=true"
import script from "./BaseDrawer.vue?vue&type=script&lang=js"
export * from "./BaseDrawer.vue?vue&type=script&lang=js"
import style0 from "./BaseDrawer.vue?vue&type=style&index=0&id=e42bb1b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42bb1b0",
  null
  
)

export default component.exports